import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import { withRouter } from 'next/router'
import {
  ANNUAL_PRICE_STRING,
  ANNUAL_50_OFF_PRICE_STRING
} from '../helpers/subscriptionHelpers'
import { HunkQuizFlow } from './hunk-quiz-20'

type PropsType = {
  bannerText: string,
  isBannerVisible: boolean
}

type DispatchPropsType = {}

function HunkQuiz50 (_props: PropsType & DispatchPropsType): React.ReactNode {
  return (
    <HunkQuizFlow
      isBannerVisible={true}
      bannerText='Happy Pride! Treat yourself to hundreds of queer sexy stories for 50% Off.'
      bannerBackground='linear-gradient(90deg, #29187F 0%, #251231 25.35%, #960049 51.81%, #F0432D 77.99%, #FF883E 100%);'
      subscriptionOfferCta='TRY 7 DAYS FREE'
      subscriptionOfferTitle={`<s>${ANNUAL_PRICE_STRING}</s> ${ANNUAL_50_OFF_PRICE_STRING} for 1 year of Dipsea`}
      subscriptionOfferSubtitle={`Discounted subscription of ${ANNUAL_50_OFF_PRICE_STRING} USD billed at 7-day trial end`}
      subscriptionOfferSubtext={`Your card will be charged a sum of ${ANNUAL_50_OFF_PRICE_STRING} USD in one week for the first year of unlimited access to Dipsea. You must cancel your subscription before the end of your one week trial if you do not want to be charged. Your annual subscription will auto-renew for $69.99 USD thereafter until you cancel. By clicking "Try 7 Days Free", you agree to our Payment Terms.`}
      existingPromoCode='hunk-quiz-50'
    />
  )
}

const mapStateToProps = (): any => {
  return {}
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HunkQuiz50) as any
) as any
